


































































































import Vue from "vue";
import Component from "vue-class-component";
import Carousel from "../../components/client/Carousel.vue";
import HomeServices from "../../components/client/HomeServices.vue";
import DynamicSections from "../../components/client/DynamicSections.vue";
import Divider from "../../components/common/Divider.vue";
import PreFooter from "../../components/common/PreFooter.vue";
import { Photo as PhotoInterface } from "../../services/settings/entities/photo.interface";
import constants from "../../config/constants";

@Component({
  components: {
    Carousel,
    HomeServices,
    DynamicSections,
    Divider,
    PreFooter
  }
})
export default class Home extends Vue {
  private mounted(): void {
    window.scrollTo(0, 0);
  }

  private goToOption(url: string): void {
    this.$router.currentRoute.path != url ? this.$router.push(url) : false;
  }

  private get clientPhotos(): Array<PhotoInterface> {
    const result = this.$store.getters["settings/getPhotos"].filter(
      (photo: PhotoInterface) => photo.photoType == constants.PHOTO_TYPE.CLIENT
    );
    return result;
  }
}
